export enum ErrorKey {
  BADREQUEST = 'bad request',
  EMAILTAKEN = 'email taken',
}
